import { useMemo } from 'react';

import { settings, useSetting } from '..';

interface UseSinglePriceSettingsProps {
  maximumFractionDigits?: number;
  minimumFractionDigits?: number;
}

export const useSinglePriceSettings = (
  _props?: UseSinglePriceSettingsProps
) => {
  const pricesDecimals = useSetting(settings.pricesDecimals());
  return useMemo(
    () => ({
      minimumFractionDigits: pricesDecimals.value,
      maximumFractionDigits: pricesDecimals.value,
      maximum: pricesDecimals.value,
      minimum: pricesDecimals.value,
    }),
    [pricesDecimals.value]
  );
};
